import axios from 'axios';

let prefix = "/user-equipment"

const UserEquipmentAdminApi = {
	listUserEquipmentAdmin(payload) {
		return axios.get(prefix + "/list-admin", { params: payload })
	},
	getUserEquipment(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
}

export default UserEquipmentAdminApi;
